import styled from "styled-components";

export default function NotFound(){
    return(
        <Content>
            <h1>Página não encontrada</h1>
            <div>
                <img src="/img/logo.png" alt="Logo SPC Escola" />
                <img src="/img/spcrio-novo.png" alt="Logo SPC Rio" />
                
            </div>
        </Content>
    )
}

const Content = styled.main`
    width: 100vw;
    height: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-top: 30px;

    h1{
        font-size: 90px;
        font-family: 'poppins', sans-serif;
        font-weight: bolder;
        color:#264b91;
    }

    img{
        height: 160px;
        margin: 40px;
    }
`